const validateSignInEntries = (email, password) => {
  let error;
  if (email && password) {
    let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let isEmailValid = emailReg.test(email.toLowerCase());
    let isPasswordValid = password.length >= 6 ? true : false;
    error = { isValid: true, message: "" };
    if (!isEmailValid || email == "") {
      error = { isValid: false, message: "Email is not valid" };
    } else if (!isPasswordValid) {
      error = { isValid: false, message: "Password is too short" };
    }
  } else {
    error = { isValid: false, message: "Please provide values" };
  }
  return error;
};

export { validateSignInEntries };
